import React from 'react';
import { Button } from 'semantic-ui-react';

export default class Print extends React.Component {

  handlePrint = () => {
    let shopName = this.props.data["shop_name"];
    if (shopName.length > 10) {
      shopName = shopName.substring(0, 10) + ".";
    }
    if (!this.props.barcode || this.props.barcode === "0") {
      alert('Please generate or enter a barcode first');
      return;
    }

    const printWindow = window.open('', '', 'height=10, width=100');
    printWindow.document.title = 'Barcode Labels';
    
    // Generate 3 labels (1 row × 3 columns)
    let labelsHtml = '';
    for (let i = 1; i <= 3; i++) {
      labelsHtml += `
        <div class="label">
          <div class="barcode-container">
            <svg id="barcode${i}"></svg>
            <p class="price">Rs. ${this.props.price}</p>
            <p  class="shop-name">${shopName}</p>
          </div>
        </div>
      `;
    }
    
    const barcodeHtml = `
      <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          <style>
            * {
              margin: 0;
              padding: 0;
            }
            html {
              width: 100%;
              height: 100%;
            }
            body {
              padding: 0;
              margin: 0;
              width: 100%;
              height: 100%;
              background: white;
            }
            .labels-container {
              display: flex;
              flex-direction: row;
              width: 100%;
              height: auto;
              padding: 0;
              margin: 0;
              page-break-after: avoid;
            }
            .label {
              width: 33.333%;
              flex: 0 0 33.333%;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              border: none;
              box-sizing: border-box;
              padding: 3mm 0.5mm 0 0.5mm;
              gap: 0;
              page-break-inside: avoid;
            }
            .barcode-container {
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              height: auto;
              gap: 0.5mm;
            }
            svg {
              display: block;
              width: 95%;
              height: auto;
              max-width: 32mm;
              max-height: 5mm;
            }
            p {
              font-size: 6px;
              margin: 0;
              line-height: 1;
            }
            .price {
              font-size: 13px;
              font-weight: bold;
              margin: 0;
              line-height: 1;
            }
            @page {
              size: 10cm 1cm;
              padding: 0;
              background-color: red;
            }
            @page :first {
              margin: 0;
              padding: 0;
            }
            @media print {
              html {
                margin: 0;
                padding: 0;
              }
              body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: auto;
              }
              .label {
                border: none;
                page-break-inside: avoid;
              }
              .labels-container {
                page-break-after: avoid;
              }
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="labels-container">
            ${labelsHtml}
          </div>
          <script>
            // Ensure all barcodes are rendered before printing
            const barcodes = [
              { id: "#barcode1", value: "${this.props.barcode}" },
              { id: "#barcode2", value: "${this.props.barcode}" },
              { id: "#barcode3", value: "${this.props.barcode}" }
            ];
            
            let rendered = 0;
            barcodes.forEach((barcode) => {
              JsBarcode(barcode.id, barcode.value, {
                format: "CODE128",
                width: 6,
                height: 100,
                margin: 5,
                displayValue: false
              });
              rendered++;
              if (rendered === barcodes.length) {
                setTimeout(() => {
                  window.print();
                  setTimeout(() => {
                    window.close();
                  }, 1000);
                }, 500);
              }
            });
          </script>
        </body>
      </html>
    `;
    printWindow.document.write(barcodeHtml);
    printWindow.document.close();
  }

  render() {
    return (
      <div>
        <Button type='submit' primary onClick={this.handlePrint}>Print</Button>
      </div>
    );
  }
}
